import { componentsConfig as defaultConfig } from "srs.sharedcomponents/lib/esm/components/config";
import WelcomeBuilder from "srs.sharedcomponents/lib/esm/components/organisms/Welcome/BuilderContent/WelcomeBuilder"
import SelectRegionComponent from "srs.sharedcomponents/lib/esm/components/region/SelectRegion";

const componentsConfig = { 
    ...defaultConfig, 
    WelcomeContent: WelcomeBuilder,
    SelectRegion: SelectRegionComponent
};

export { componentsConfig };